import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import Image from 'next/image';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='Albert Chuang'
        dateTime='2021-06-24'
        tag='Funding'
        title='OneShop joins Y Combinator’s Summer 2021 Batch'
      >
        <br />
        <Image src='/static/images/yc-s21-og-image.png?v=1' width={1310} height={655} alt='YC' loading='eager' />
        <p>
          Both{' '}
          <a href='https://linkedin.com/in/aaronptb' target='_blank'>
            Aaron
          </a>{' '}
          and{' '}
          <a href='https://linkedin.com/in/yonajune' target='_blank'>
            I
          </a>{' '}
          are excited to share that OneShop is part of{' '}
          <a href='https://ycombinator.com' target='_blank'>
            Y Combinator
          </a>
          ’s summer batch this year.
        </p>

        <p>
          OneShop is making selling on e-commerce marketplaces easier. We’re building listing, marketing, and analytics
          tools for sellers so they can more effectively run their business on marketplaces like Poshmark and Mercari.
        </p>

        <p>
          Being part of Y Combinator has materially improved how we're building OneShop and given us a much-needed
          period of time to focus on better serving our customers.
        </p>

        <p>
          Twice a year, the Silicon Valley based firm aims to fund the next generation of category-defining companies.
          Its portfolio has a combined valuation of $300B. Some notable alumni include Airbnb, DoorDash, Instacart,
          Dropbox, and Coinbase.
        </p>

        <p>
          We're also hiring software engineers! If you’re interested you can email Albert at{' '}
          <a href='mailto:albert@oneshop.com' target='_blank'>
            albert@oneshop.com
          </a>{' '}
          and view our openings on the{' '}
          <a href='https://www.workatastartup.com/companies/oneshop' target='_blank'>
            Work at a Startup job board
          </a>
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
